import { ApiStore, Widget, rotationModes } from '@hart-estate/widget';
import '../assets/sass/index.sass';
import logo from '../assets/img/logo.png';

const WIDGET_API_URL = 'https://backend.estate.hart-digital.com';

const createWidget = async (logoUrl) => {
  const widgetApiHandler = new ApiStore(WIDGET_API_URL)

  const searchParams = (new URL(document.location)).searchParams;
  const planId = searchParams.get("id");

  const planData = await widgetApiHandler.loadWidgetData(planId);
  const options = {
    ...planData.parsed,
    API_URL: WIDGET_API_URL,
    rotationMode: rotationModes.DEFAULT,
    logo: logo,
    tabs: ['panorama', 'rotation'],
    locale: 'ja',
    logoUrl,
    dictionaryOverrides: {
      'made-by-text': 'express-pers.jp',
      'made-by-link': 'https://express-pers.jp/',
      'research-plan': 'アイコンをタップで移動できます',
      'rotate-plan': 'ドラッグで見渡せます',
    },
    colors: {
      main: '#0185B2',
      mainText: '#413e3e'
    },
    enableCameraTransitionBetweenPanoramas: false,
    designType: 'standard',
    tabsButtonsDesign: 'two'
  }

  new Widget('#widget', options);
}

createWidget('https://express-pers.jp/');
